import { MapPin, Phone, EnvelopeSimple, InstagramLogo } from "@phosphor-icons/react";
import { Chapter, Reveal } from "@/components/site/Reveal";

const INSTAGRAM_URL =
    "https://www.instagram.com/treasurevalleyturf?igsh=MXdnbHdqemhjZ2Rxcw%3D%3D&utm_source=qr";

const CONTACT = [
    {
        icon: MapPin,
        label: "Service area",
        value: "Treasure Valley, Idaho",
        href: null,
    },
    {
        icon: Phone,
        label: "Phone",
        value: "(208) 605-9096",
        href: "tel:+12086059096",
    },
    {
        icon: EnvelopeSimple,
        label: "Email",
        value: "treasurevalleyturf@gmail.com",
        href: "mailto:treasurevalleyturf@gmail.com",
    },
    {
        icon: InstagramLogo,
        label: "Instagram",
        value: "@treasurevalleyturf",
        href: INSTAGRAM_URL,
        external: true,
    },
];

export const ContactSection = () => {
    return (
        <section
            id="contact"
            data-testid="contact-section"
            className="border-t border-brand-border/60 bg-white py-24 md:py-36"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-10">
                <Chapter
                    index="09"
                    label="Contact"
                    testid="contact-chapter"
                    title={
                        <>
                            Want to chat?{" "}
                            <span className="italic text-brand-accent">Reach out directly</span>.
                        </>
                    }
                />

                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                    {CONTACT.map((c, i) => {
                        const Icon = c.icon;
                        const inner = (
                            <>
                                <div className="grid h-10 w-10 place-items-center rounded-lg bg-brand-accent/10 ring-1 ring-brand-accent/30">
                                    <Icon
                                        size={20}
                                        weight="duotone"
                                        className="text-brand-accent"
                                    />
                                </div>
                                <p className="mt-5 text-xs font-bold uppercase tracking-[0.18em] text-brand-muted">
                                    {c.label}
                                </p>
                                <p className="font-display mt-2 break-all text-base font-medium leading-tight text-brand-text transition-colors group-hover:text-brand-accent sm:text-lg">
                                    {c.value}
                                </p>
                            </>
                        );
                        const classes =
                            "spotlight group block h-full rounded-2xl border border-brand-border bg-white p-6 transition-colors duration-500 hover:border-brand-accent/40";
                        return (
                            <Reveal key={c.label} delay={i * 0.06} className="h-full">
                                {c.href ? (
                                    <a
                                        href={c.href}
                                        target={c.external ? "_blank" : undefined}
                                        rel={c.external ? "noopener noreferrer" : undefined}
                                        data-testid={`contact-card-${i}`}
                                        className={classes}
                                    >
                                        {inner}
                                    </a>
                                ) : (
                                    <div data-testid={`contact-card-${i}`} className={classes}>
                                        {inner}
                                    </div>
                                )}
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
